/**
 * Каноническая часть речи — та же таблица, что `canonical_pos` на бэке
 * (cards_worker_service.py): строки словаря и значения карточки сравниваются по ней.
 * Причастие для ученика — строка прилагательного.
 */
const POS_CANON: Record<string, string> = {
  noun: 'noun',
  n: 'noun',
  name: 'noun',
  'proper noun': 'noun',
  verb: 'verb',
  v: 'verb',
  'phrasal verb': 'verb',
  phrasal_verb: 'verb',
  adjective: 'adjective',
  adj: 'adjective',
  participle: 'adjective',
  adverb: 'adverb',
  adv: 'adverb',
  preposition: 'preposition',
  prep: 'preposition',
  pronoun: 'pronoun',
  pron: 'pronoun',
  conjunction: 'conjunction',
  conj: 'conjunction',
  interjection: 'interjection',
  intj: 'interjection',
  numeral: 'numeral',
  num: 'numeral',
  determiner: 'determiner',
  det: 'determiner',
  phrase: 'phrase',
};

export function canonicalPos(pos: string | null | undefined): string | null {
  const value = (pos ?? '').trim().toLowerCase();
  if (!value) return null;
  return POS_CANON[value] ?? value;
}
